if (!customElements.get("td-quantity-input")) {
  class TdQuantityInput extends HTMLElement {
    constructor() {
      super();
      this.minusBtn = this.querySelector('.minus');
      this.plusBtn = this.querySelector('.plus');
      this.input = this.querySelector('.td-qsf__input--standard');
    }

    connectedCallback() {
      if (!this.minusBtn || !this.plusBtn || !this.input) {
        console.warn("TdQuantityInput: Required elements are missing");
        return;
      }

      this.minusBtn.addEventListener('click', () => this.decreaseQuantity());
      this.plusBtn.addEventListener('click', () => this.increaseQuantity());
      this.input.addEventListener('input', () => this.handleInputChange());
    }

    decreaseQuantity() {
      const currentValue = parseInt(this.input?.value) || 0;
      if (currentValue > 0) {
        this.input.value = currentValue - 1;
        this.triggerInputEvent();
      }
    }

    increaseQuantity() {
      const currentValue = parseInt(this.input?.value) || 0;
      this.input.value = currentValue + 1;
      this.triggerInputEvent();
    }

    handleInputChange() {
      let value = parseInt(this.input?.value);
      if (isNaN(value) || value < 0) {
        this.input.value = 0;
      }
    }

    triggerInputEvent() {
      if (!this.input) return;
      const event = new Event('input', { bubbles: true, cancelable: true });
      this.input.dispatchEvent(event);
    }
  }

  customElements.define("td-quantity-input", TdQuantityInput);
}
